import { render } from "./Emailcampaign.vue?vue&type=template&id=68110960"
import script from "./Emailcampaign.vue?vue&type=script&lang=js"
export * from "./Emailcampaign.vue?vue&type=script&lang=js"

import "./Emailcampaign.vue?vue&type=style&index=0&id=68110960&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__